// import dashboardData from '../../../assets/static-content/dashboard.json';
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { CmsImage } from '../../../CmsImage';
import { EXCLUSIVE_REWARDS_TRANSLATIONS } from '../i18n';
import { BackIcon } from '../icons';

interface HeaderProps {
  isGiftOffersAvailable: boolean;
  brandLogoUrl: string;
  handleBack: () => void;
}

const Header: React.FC<HeaderProps> = ({
  isGiftOffersAvailable,
  brandLogoUrl,
  handleBack,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(
    EXCLUSIVE_REWARDS_TRANSLATIONS,
    context,
  );

  return (
    <div className="flex flex-row items-start justify-evenly w-full bg-primary-900 h-auto pb-8 md:pb-12 md:pt-0 sm:pb-4">
      <div className="flex flex-row w-full lg:w-page-max md:justify-between p-4 md:p-6 lg:px-0">
        <p className="grow content-end alpha-display-2 text-white pr-2 md:pr-0">
          {isGiftOffersAvailable
            ? staticText.giftsAvailable
            : staticText.giftsNotAvailable}
        </p>
        <div className="flex flex-col items-end text-primary-100 text-sm md:text-base font-medium leading-5 cursor-pointer">
          <div
            tabIndex={0}
            role="button"
            className="flex flex-row-reverse md:flex-row gap-1 pb-1 outline-none"
            onClick={handleBack}
          >
            <BackIcon />
            <span className="underline">{staticText.back}</span>
          </div>
          <div className="w-25 shrink-0 grow-0 md:w-35 h-9">
            <CmsImage
              sizes={{ _: 140 }}
              src={brandLogoUrl}
              alt="Provider logo"
              width={140}
              height={36}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
